var React = require('react');

function AvatarInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"12.8","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("ellipse",{"cx":"15.9999","cy":"12.8","rx":"4.8","ry":"4.8","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 26.4V26.4C8 23.3072 10.5072 20.8 13.6 20.8H18.4C21.4928 20.8 24 23.3072 24 26.4V26.4","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

AvatarInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = AvatarInline;

AvatarInline.default = AvatarInline;
